<template>
  <div>
    <el-form
      :model="ruleForm"
      ref="ruleForm"
      label-width="auto"
      class="demo-ruleForm"
    >
      <el-form-item prop="telephone">
        <el-input
          v-model="ruleForm.telephone"
          clearable
          placeholder="请输入账户"
        >
          <i slot="prefix" class="el-input__icon el-icon-user"></i>
        </el-input>
      </el-form-item>

      <el-form-item prop="pass">
        <el-input
          v-model="ruleForm.pass"
          clearable
          placeholder="请输入账户密码"
          type="password"
        >
          <i slot="prefix" class="el-input__icon el-icon-lock"> </i>
        </el-input>
      </el-form-item>

      <el-form-item class="form_item_btn">
        <el-button class="btn_submit" type="success" @click="submitForm"
          >登录</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import utils from "@/util/index";
import md5 from "js-md5";
import { doLogin } from "@/network/loginRequest/api";

export default {
  data() {
    return {
      ruleForm: {
        telephone: "",
        pass: "",
      },
    };
  },
  mounted() {
    utils.tips("warning", "请注意，密码输入只有三次机会");
  },

  methods: {
    submitForm() {
      let form = this.ruleForm;
      let RegPhone = new RegExp(
        /^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$/
      ); //验证手机号
      if (form.telephone == "") {
        utils.tips("warning", "账号不能为空");
      } else if (!RegPhone.test(form.telephone)) {
        utils.tips("warning", "请输入正确的手机号码");
      } else if (form.pass == "") {
        utils.tips("warning", "请输入密码");
      } else {
        let fd = new FormData();
        fd.append("telephone", form.telephone);
        fd.append("password", md5(form.pass));
        fd.append("type", "0");
        fd.append("account", form.telephone);
        doLogin(fd)
          .then((res) => {
            let response = res.data.data;
            //可以在axios响应处保存，懒得改了
            if (res.data.success) {
              //登录成功
              //修改vuex的登录状态
              this.$store.commit("isLogin", true);
              //修改用户id
              this.$store.commit("setUserId", response.sessionUser.userId);
              //修改用户信息--------------------------------------------
              this.$store.commit("setUser", response.sessionUser);
              //把vuex保存在浏览器 防止用户刷新页面时vuex数据重置
              utils.setSess("store", JSON.stringify(this.$store.state));
              //保存token到sessionStorage
              utils.setSess("loginMessage", response.token);
              //将验证保存到sessionStorage
              utils.setSess("Authorazition", res.headers.authorazition);
              console.log("登录===ling", this.$bus.loginChecked);
              //是否记住登录状态
              if (this.$bus.loginChecked) {
                //保存1天
                utils.setCookie(
                  "loginMessage",
                  response.token,
                  1 * 24 * 60 * 60 * 1000
                );
                utils.setCookie(
                  "userId",
                  response.sessionUser.userId,
                  1 * 24 * 60 * 60 * 1000
                );
                utils.setCookie(
                  "user",
                  response.sessionUser,
                  1 * 24 * 60 * 60 * 1000
                );
                utils.setCookie(
                  "Authorazition",
                  res.headers.authorazition,
                  1 * 24 * 60 * 60 * 1000
                );
              } else {
                utils.clearCookie("loginMessage");
                utils.clearCookie("userId");
                utils.clearCookie("Authorazition");
              }

              this.$router.push({
                name: "ResourceCenter",
              });
            } else {
              utils.tips("warning", res.data.code);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.el-form {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .form_item_btn {
    margin-top: 10px;
  }

  .el-form-item:nth-child(3) {
    margin-bottom: 10px;
  }

  .el-form-item {
    margin-bottom: 30px;
    width: 100%;
    .btn_submit {
      border-color: #24ba58;
      width: 100%;
      background-color: #24ba58;
    }

    .el-button--success:active {
      border-color: skyblue;

      background-color: skyblue;
    }

    /deep/ .el-input__inner:focus {
      border-color: #24ba58;
    }
  }
}
</style>
